export { CATALOG_DESKTOP_VIEW_MODE_DEFAULT } from 'src/features/catalog';
export {
  CATALOG_DESKTOP_COLUMN_WIDTH_FIXED,
  CATALOG_DESKTOP_ITEM_CARD_WIDTH_MAX,
  CATALOG_MOBILE_COLUMN_SPACING,
  CATALOG_DESKTOP_COLUMN_SPACING,
} from 'src/widgets/catalog';
export const CATALOG_MAP_OVERLAY_OPACITY = 0.7;
export const CATALOG_MOBILE_UPPER_PART_BOTTOM_SPACING = 16;
export const CATALOG_DESKTOP_CONTAINER_MAX_WIDTH = 1140;
export const CATALOG_MOBILE_COLUMN_WIDTH_FIXED = 170;
export const CATALOG_VACANCY_SUBTITLE = 'Зарегистрируйтесь, чтобы откликаться на лучшие вакансии!';
export const CATALOG_RESUME_SUBTITLE = 'Зарегистрируйтесь, чтобы найти домашний персонал!';
